import { StoreApi, UseBoundStore, useStore } from "zustand";
import {
  WhatsAppContactsStoreType,
  whatsappContactsStore,
} from "./whatsapp-contacts-store";
import {
  whatsappContactsPersistentStore,
  WhatsAppContactsPersistentStoreType,
} from "./whatsapp-contacts-persistent-store";

export const useWhatsAppContactsStore = useStore.bind(
  null,
  whatsappContactsStore.getStore()
) as UseBoundStore<StoreApi<WhatsAppContactsStoreType>>;

export const useWhatsAppContactsPersistentStore = useStore.bind(
  null,
  whatsappContactsPersistentStore.getStore()
) as UseBoundStore<StoreApi<WhatsAppContactsPersistentStoreType>>;
